<template>

    <v-snackbar v-model="$store.state.connectionSnackbar.active" :timeout="1200" right top>
        <div class="new-connection-container">
            <div class="avatar-container">
                <img :src="userImage" v-if="userImage" />
                <v-icon x-large v-if="!userImage">fa fa-user-circle</v-icon>
            </div>
            
            <span class="username" :class="{disconnected: !userState}">{{ userName }}</span>
            <span class="state" :class="{disconnected: !userState}">{{ `${userState ? 'connected' : 'disconnected'}` }}</span>

            <v-btn color="#ffffff" class="close-button" icon @click="closeSnackbar"><v-icon>mdi-close</v-icon></v-btn>
        </div>
    </v-snackbar>
    
</template>

<script>
export default {
    name: 'ConnectionSnackbar',
    props: [],
    components: {

    },
    data: () => ({

    }),

    computed: {
        userName: function() {
            return this.$store.state.connectionSnackbar.active ? this.$store.state.connectionSnackbar.user.username : null;
        },

        userState: function() {
            return this.$store.state.connectionSnackbar.active ? this.$store.state.connectionSnackbar.loggingIn : null;
        },

        userImage: function() {
            if(!this.$store.state.connectionSnackbar.active) {
                return null;
            }

            let user = this.$store.state.batchConfig.users.find(u => {return u.user_id == this.$store.state.connectionSnackbar.user.user_id});
            return user.userImage || null;
        }
    },

    methods: {
        closeSnackbar: function() {
            this.$store.commit('closeConnectionSnackbar');
        }

    },

    created() {
    },

    mounted() {

    }

  
};
</script>

<style>

    .v-snack--right .v-snack__wrapper {
        margin-right: 20px;
    }


</style>

<style scoped>

    .new-connection-container {
        position: relative;
        width: 100%;

    }

    .avatar-container {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        /* position: absolute; */
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
        display: inline-block;
        vertical-align: middle;
    }
    .avatar-container img {
        border-radius: 50%;
        height: 40px;
        width: 40px;
    }

    .username {
        position: relative;
        color: #ffffff;
        text-align: left;
        margin-left: 10px;
        margin-right: 5px;
        font-weight: bold;
        font-size: 18px;
    }
    .username.disconnected {
        color: #ffffffa0;
    }

    .state {
        position: relative;
        color: #ffffff;
        font-size: 14px;
    }
    .state.disconnected {
        color: #ffffffa0;
    }
    

    .close-button {
        position: absolute;
        right: 0;
    }

</style>
